import { SavedFilterData } from './../../modules/shared/models/filter.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/modules/shared/services/http.service';
import { environment } from 'src/environments/environment';
import { GelAllCasesRequestModel, GetAllCasesGroupByRequest } from '../models/cases.model';
import { Observable } from 'rxjs';
import { TypeGroupIds } from '../../modules/shared/constants/category-groupid.constants';

@Injectable({
  providedIn: 'root'
})
export class CasesService {

  appUrl = "";
  appCore = "";
  casesUrl: string;
  configUrl: string;
  appOrgUrl: string;
  constructor(
    private httpService: HttpService,
    private http: HttpClient
  ) {
    this.casesUrl = environment.accountCasesUrl;
    this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
    this.appUrl = environment.appUrl;
    this.configUrl = `${environment.configUrl}Configuration/`;
    this.appOrgUrl = environment.appOrgUrl;
  }

  getStages(data: {
    accountChannelId: number,
    channelId: number,
    isActive: boolean,
    Filter: string | null,
  }) {
    return this.http.get(`${this.casesUrl}Ticket/v2/StageWiseCount/Channel/${data?.channelId}?IsActive=${data?.isActive}&accountChannelId=${data?.accountChannelId}&Filter=${data?.Filter}`);
  }

  getAllCasesList(data: GelAllCasesRequestModel) {
    return this.httpService.create(`${this.casesUrl}Ticket/v2/GetPagedList`, data);
  }

  getCasesListWithFilters(requestModel: GelAllCasesRequestModel){
    return this.httpService.create(`${this.casesUrl}Ticket/v2/GetPagedListWithFilter`, requestModel);
  }

  getCasesGroupList(requestModel: GetAllCasesGroupByRequest){
    return this.httpService.create(`${this.casesUrl}Ticket/v2/GetGroupedPagedList`, requestModel);
  }

  getCasesById(id) {
    return this.http.get(`${this.casesUrl}Ticket/V2/${id}`);
  }

  getAllContactAssociation(): Observable<any> {
    return this.http.get<any>(`${this.casesUrl}Type?groupId=${TypeGroupIds.ContactAssociationTicketAPI}`);
  }

  getCaseConfigurations() {
    return this.http.get<any>(`${this.configUrl}ConfigurationsByModuleName?name=case`)
  }

  getAllTypes() {
    return this.http.get<any>(`${environment.appOrgUrl}Type`)
  }

  getCaseCategories() {
    return this.http.get<any>(`${environment.appUrl}Category/GetAll`);
  }

  getResolutionDays(resolutionDays: number) {
    return this.http.get(`${environment.appUrl}Category/GetResolutionDayWiseDate?resolutionDay=${resolutionDays}`,
      {
        responseType: 'text'
      });
    // .toPromise()
    // .then(res => res.text());
  }

  getUserGroups(organizationId: number): Observable<any[]> {
    return this.http.get<any>(`${this.appOrgUrl}UserGroup/GetMyUserGroups?groupId=0`, {
      // return this.http.get<any>( `${environment.appOrgUrl}UserGroup?groupId=0`, {
      headers: new HttpHeaders({
        "organizationId": `${organizationId}`
      })
    });
  }

  addCase(caseData): Observable<any> {
    return this.http.post<any>(`${this.appUrl}Ticket`, caseData);
  }

  getPagedListKanban(data: GelAllCasesRequestModel) {
    return this.http.post(`${this.casesUrl}Ticket/v2/GetPagedListKanban`, data);
  }


  updateCase(caseData) {
    return this.http.put<any>(`${this.appUrl}Ticket`, caseData);
  }

  deleteCase(caseId) {
    return this.http.delete<any>(`${this.appUrl}Ticket/${caseId}`);
  }

  assignUser(tickedId: number, data) {
    return this.http.post<any>(`${this.appUrl}Ticket/AssignUser/${tickedId}`, data)
      .toPromise()
      .then(res => res);
  }


  saveFilterDataChannalWise(data: {moduleId: number, channelId: number , filterData: SavedFilterData}){
    return this.http.post<any>(`${environment.configUrlV2 + "/ColumnFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`, data?.filterData);
  }

  getSavedFilterDataChannalWise(data: {moduleId: number, channelId: number}){
    return this.http.get<any>(`${environment.configUrlV2 + "/ColumnFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
  }

  resetSavedFilterChannelWise(data: {moduleId: number, channelId: number}){
    return this.http.delete<any>(`${environment.configUrlV2 + "/ColumnFilter/ResetFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
  }

  resetSavedGroupByChannelWise(data: {moduleId: number, channelId: number}){
    return this.http.delete<any>(`${environment.configUrlV2 + "/ColumnFilter/ResetGroupBy/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
  }

}
